import moment from "moment";
import { PAST_DAYS, FUTURE_DAYS } from "../settings";
// import "moment/locale/de";
// import "moment/locale/en-gb";
export default class DateHelper {
    getToday() {     
       // moment.locale("en");
        console.log("Date helper props :", this.props);
        
        // console.log(new Date(setting))
        let ret = moment(new Date()).startOf("day");
        // let loadLastVisited = localStorage.getItem("LoadLastVisited");
        // if(loadLastVisited){
        //     let setting = localStorage.getItem("LastVisitedDate");
        //     ret = moment(new Date(setting)).startOf("day");
        //     localStorage.setItem("LoadLastVisited", true);
        // }
        // if(ret1 !== ret) ret = ret1;
        //let ret = moment(new Date("29 Mart, 2023")).startOf("day");  //FOR TESTING PURPOSE
        if (ret.isoWeekday() === 6) ret = ret.add(2, "days");
        if (ret.isoWeekday() === 7) ret = ret.add(1, "days");
        return ret;
    }
    getStartDate() {
        let startD = this.getToday();
        for (let i = 0; i < PAST_DAYS; i++) {
            let dayIndex = startD.isoWeekday();
            if (dayIndex === 1) startD = startD.add(-3, "days");
            else startD = startD.add(-1, "days");
        }
        return startD;
    }

    getDateByIndex(index) {
        let day = this.getStartDate();

        for (let i = 0; i < index; i++) {
            let dayIndex = day.isoWeekday();
            if (dayIndex === 5) day = day.add(3, "days");
            else if (dayIndex === 6) day = day.add(2, "days");
            else day = day.add(1, "days");
        }
        return day;
    }

    getTodayIndex() {
        let startD = this.getToday();
        for (let i = 0; i <= PAST_DAYS + FUTURE_DAYS; i++) {
            if (startD === this.getDateByIndex(i)) return i;
        }
        return PAST_DAYS;
    }

    isTheSameDate(d1, d2) {
        return (
            d1.date() === d2.date() &&
            d1.month() === d2.month() &&
            d1.year() === d2.year()
        );
    }

    appDuration(d1,d2){
        return d2.date()-d1.date();
    }

    inPreviousThreeDays(d1){
        let today = new Date();
        let past = moment(today.setDate(today.getDate() - 3));

        return (
            d1.date() >= past.date() && 
            d1.month() >= past.month() &&
            d1.year() >= past.year()
        );
    }

    getTodayTime() {
        return moment(new Date()).format("HH:mm");
    }
}
